// import l from '../../../../../system/libraries/select2_4/select2.full.min';

import $ from 'jquery';
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap;
var initialisePopovers = () => {
  $('.popover-item').each( function (e){
    // Sets up any old popover items to work with new bootstrap5 popovers
    $(this).attr('data-bs-content', $(this).attr('data-content'));
    $(this).attr('title', $(this).attr('data-title'));
    return new bootstrap.Popover(this, {
      container: '#content-wrapper',
      html: true,
      // trigger: "hover focus",
      trigger: "click",
      delay: 125,
    })

  })
}
var initialiseTooltips = () => {
  $('[data-tooltip], [data-toggle="tooltip"]').each( function (e){
    // Sets up any old popover items to work with new bootstrap5 popovers
    $(this).attr('data-bs-toggle', 'tooltip');
    $(this).removeAttr('data-toggle').removeAttr('aria-controls');
    $(this).attr('data-bs-placement', $(this).attr('data-placement'));
    $(this).attr('data-bs-html', 'true');
    $(this).attr('title', $(this).attr('data-original-title'));
    $(this).attr('data-bs-content', $(this).attr('data-content'));
  });
  $('[data-bs-toggle="tooltip"], [data-tooltip], [data-toggle="tooltip"]').each( function (e){
    return new bootstrap.Tooltip($('body'), {
      container: '#pusher',
      trigger: 'hover focus',
      selector: '[data-bs-toggle="tooltip"], [data-tooltip], [data-toggle="tooltip"]',
    });
  });
}
var initialiseAbbrs = () => {
  $('abbr[title]:not([data-bs-toggle="tooltip"])').each( function (e){
    var tooltip = new bootstrap.Tooltip($(this))
    $(this).on('blur', function () {
      $(this).tooltip('hide');
    })
  });
}
var initialiseDropdowns = () => {
  return new bootstrap.Dropdown(document.body, {
    container: '#pusher',
    trigger: 'click',
    selector: '[data-bs-toggle="dropdown"]',
  })
}

document.addEventListener('DOMContentLoaded', initialiseTooltips, false);
document.addEventListener('DOMContentLoaded', initialiseAbbrs, false);
document.addEventListener('DOMContentLoaded', initialisePopovers, false);
// document.addEventListener('DOMContentLoaded', initialiseDropdowns, false);